import { createFileRoute } from "@tanstack/react-router"

import { Stack } from "@chakra-ui/react"

import Summary from "../components/Summary"

const OrderConfirmationRoute: React.FC = () => {
  return (
    <>
      <Stack>
        <Summary />
      </Stack>
    </>
  )
}

export const Route = createFileRoute("/summary")({
  component: OrderConfirmationRoute,
})
